import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { Fetch, baseUrl } from "../../../shared/Fetch";
import { format } from "date-fns";
import { ISalEffFilter } from "./Filter";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Publish } from "../../requirement/Publish";
import { ILogin } from "../../../models/Login";
import { safeFormatDate } from "../../../models/DateFormatMapper";
import { Interview_Process } from "../../../models/RequirementMast";

interface Iprops {
    open: boolean,
    hideDialog: () => void,
    toast: any,
    salEffFilter: ISalEffFilter,
    salesID?: number,
    resType: number
}

export const SubTable = (props: Iprops) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<{ sn: number }>, loading: boolean });
    const [publish, setPublish] = useState({ singleData: {}, open: false } as { singleData: { req_ID?: number }, open: boolean });
    const dt = useRef<any>(null);

    const exportCSV = () => {
        dt.current.exportCSV();
    };
    let _role: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _role.push(role.role_ID);
    });

    useEffect(() => {
        if (props.open) {
            if (props.resType === 9 || props.resType === 10 || props.resType === 20) {
                loadTableDataSalesReport();
            } else {
                loadTableData();
            }
            // console.log(props.resType)
        }
    }, [props.open]);

    const loadTableData = async () => {
        setTableData({ tableData: [], loading: true });
        let filterQuery = "";
        if (props.salesID)
            filterQuery += `&salesID=${props.salesID}`;
        let response;
        if (props.resType === 11) response = await Fetch("Report_Sales/saldetail", "GET", null, `filter=${JSON.stringify(props.salEffFilter)}&resType=${1}` + filterQuery, props.toast);
        else
            response = await Fetch("Report_Sales_Efficiency/report", "GET", null, `filter=${JSON.stringify(props.salEffFilter)}&resType=${props.resType}` + filterQuery, props.toast);
        if (response) {
            const data: Array<{ sn: number }> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    const loadTableDataSalesReport = async () => {
        let filterQuery = "";
        if (props.salesID)
            filterQuery += `&salesID=${props.salesID}`;
        setTableData({ tableData: [], loading: true });
        console.log("props", props);
        const ResType = props.resType;
        const response = await Fetch("Report_Sales/reqsaldetail", "GET", null, `filter=${JSON.stringify(props.salEffFilter)}&resType=${ResType}` + filterQuery, props.toast);
        if (response) {
            const data: Array<{ sn: number }> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    const subDate = (rowData: { subDate: Date }) => {
        let date;
        if (rowData.subDate) date = format(new Date(rowData.subDate), 'dd/MM/yyyy hh:mm a').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const onHide = () => {
        props.hideDialog();
    }

    const downloadResume = async (path: string) => {
        const params = {
            method: "GET",
            headers: {
                'Content-Type': 'application/msword',
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            }
        };
        try {
            const response = await fetch(`${baseUrl}${"Resume_Mast/download"}?path=${path}`, params);
            if (response.status === 200) {
                const blob = await response.blob();
                const href = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.download = `${path}`;
                a.href = href;
                a.click();
                a.href = '';
            } else if (response.status === 400) {
                const message = await response.text();
                props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
            }
        } catch {
            props.toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
        }
    }

    const consultant_Name = (rowData: { consultant_Name: string, consultant_Resume_Path: string }) => <span onClick={() => downloadResume(rowData.consultant_Resume_Path)}
        className="cursor-pointer text-cyan-700 underline">{rowData.consultant_Name}</span>

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Sales Submission Report</h5>
            <Button label="Export" icon="pi pi-upload" className="p-button-help w-8rem mr-3" onClick={exportCSV} />
        </div>
    );

    const req_Job_Title = (rowData: { req_ID: number, req_Job_Title: string }) => {
        return (<span onClick={() => setPublish({ singleData: { req_ID: rowData.req_ID }, open: true })}
            className="cursor-pointer text-cyan-700 underline">
            {rowData.req_Job_Title}
        </span>);
    };
    const hidePublishDialog = () => {
        setPublish({ singleData: {}, open: false });
    };
    const addOn = (rowData: { addOn: Date }) => {
        let date;
        if (rowData.addOn) date = format(new Date(rowData.addOn), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const rowClass = (data: any) => {

        return {
            'bg-green-300 text-white': props.resType === 11 && data.client_BG_Color === 1,
            'bg-purple-300 text-white': props.resType === 11 && data.client_BG_Color === 2

        };
    }

    const DateFormat = loginObj.date_Format;

    return (props.open && (props.resType === 9 || props.resType === 10 || props.resType === 20)) ? (
        <Dialog visible={props.open} style={{ width: '80vw' }} header={header} modal className="p-fluid" onHide={onHide}>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }} exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                ref={dt} size="small" stripedRows showGridlines scrollable scrollHeight="70vh"
                value={tableData.tableData}
                loading={tableData.loading}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="req_ID" header="Req ID" sortable />
                <Column field="req_Job_Title" header="Job Title" body={req_Job_Title} />
                <Column field="req_Duration" header="Duration" />
                <Column field="location" header="Location" />
                <Column field="req_Rate" header="Rate" />
                <Column field="req_InterviewProcess" header="InterviewProcess" body={(rowData: any) => rowData.req_InterviewProcess ? Interview_Process[rowData.req_InterviewProcess] : ""} />
                <Column field="resume" header="#Resume" sortable />
                <Column field="eci" header="#ECI" sortable />
                <Column field="po" header="#PO" sortable />
                <Column field="status" header="Status" />
                <Column field="accSub" header="#AccSub" />
                <Column field="rejSub" header="#RejSub" />
            </DataTable>
            <Publish singleData={publish.singleData} open={publish.open} hideDialog={hidePublishDialog} toast={props.toast} />
        </Dialog>
    ) : (
        <Dialog visible={props.open} style={{ width: '80vw' }} header={header} modal className="p-fluid" onHide={onHide}>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }} exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                ref={dt} size="small" stripedRows showGridlines scrollable scrollHeight="70vh"
                value={tableData.tableData}
                loading={tableData.loading}
                rowClassName={rowClass}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                {props.resType !== 11 && <Column field="req_ID" header="Req.ID" sortable />}
                {props.resType !== 11 && <Column field="consultant_Name" header="Consultant Name" body={consultant_Name} />}
                {props.resType !== 11 && <Column field="sales_Person_Name" header="Sales Manager" />}
                {props.resType !== 11 && <Column field="recruiter" header="Recruiter" />}
                {props.resType !== 11 && <Column field="req_Job_Title" header="Job Title" body={req_Job_Title} />}
                {props.resType !== 11 && <Column field="req_EndClient" header="End Client" />}
                {props.resType !== 11 && !_role.includes(40) && <Column field="vendor_Company_Name" header="Prime Vendor" />}
                {props.resType !== 11 && <Column field="subVendor" header="Sub Vendor" />}
                {/* {props.resType !== 11 && <Column field="subDate" header="Sub Date" body={subDate} />} */}
                {props.resType !== 11 && <Column field="subDate" header="Sub Date" body={(rowData: any) => safeFormatDate(rowData.subDate, "dd/MM/yyyy", DateFormat, true)} />}
                {props.resType !== 11 && <Column field="status_Name" header="Status" />}
                {props.resType !== 11 && <Column field="comments" header="Comment" />}
                {props.resType === 11 && <Column field="req_ID" header="Req ID" sortable />}
                {props.resType === 11 && !_role.includes(40) && <Column field="vendor_Company_Name" header="Vendor Company" />}
                {props.resType === 11 && !_role.includes(40) && <Column field="contact_Person_Name" header="Contact Person" />}
                {/* {props.resType === 11 && <Column field="addOn" header="AddOn" body={addOn} />} */}
                {props.resType === 11 && <Column field="addOn" header="AddOn" body={(rowData: any) => safeFormatDate(rowData.addOn, 'dd/MM/yyyy', DateFormat)} />}
                {props.resType === 11 && <Column field="req" header="#Req" sortable />}
                {props.resType === 11 && <Column field="f2f" header="#F2F" sortable />}
                {props.resType === 11 && <Column field="noF2F" header="#NoF2F" sortable />}
                {props.resType === 11 && <Column field="served" header="#Served" sortable />}
                {props.resType === 11 && <Column field="unServed" header="#UnServed" sortable />}
                {props.resType === 11 && <Column field="sub" header="#Sub" sortable />}
                {props.resType === 11 && <Column field="eci" header="#ECI" sortable />}
                {props.resType === 11 && <Column field="po" header="#PO" sortable />}
            </DataTable>
            <Publish singleData={publish.singleData} open={publish.open} hideDialog={hidePublishDialog} toast={props.toast} />

        </Dialog>

    )
}